export const SCREENS = {
  HOME: `HOME`,
  MESSAGES: `MESSAGES`,
  MARKETPLACE: `MARKETPLACE`,
  FIND_A_DOCTOR: `FIND_A_DOCTOR`,
  ACCOUNT: `ACCOUNT`,
  ADMIN: `ADMIN`,
  LOGOUT: `LOGOUT`,
};

/** Permanent drawer only — avoids Joyride targeting the hidden mobile drawer duplicate. */
export const INTRO_TOUR_MY_BENEFITS_NAV_DOM_ID = 'bennie-intro-tour-my-benefits';
